export const FUSION_UI_VIEW_PREFIX = 'CnLayout-layout-view';
export const PAGE = 'CnLayoutPage';
export const PAGE_HEADER = 'CnLayoutHeader';
export const PAGE_ASIDE = 'CnLayoutAside';
export const PAGE_CONTENT = 'CnLayoutContent';
export const SECTION = 'CnLayoutSection';
export const BLOCK = 'CnLayoutBlock';
export const TILE = 'CnTile';
export const CELL = 'CnLayoutCell';
export const ROW = 'CnLayoutRow';
export const COL = 'CnLayoutCol';
// 缓存折叠状态
export const cacheFoldStore = {};
